import { ActionTree, ActionContext } from 'vuex';

import { RootState } from '@/store';

import { State } from './state';
import { Mutations } from './mutations';
import { CountriesMutationTypes } from '@/core/enum/Countries/Mutations';
import { CountriesActionTypes } from '@/core/enum/Countries/Actions';
import { Links } from '@/core/enum/Links';
import axios from 'axios';
import { isCalled } from '@/store/stateless';

type AugmentedActionContext = {
  commit<K extends keyof Mutations>(
    key: K,
    payload: Parameters<Mutations[K]>[1],
  ): ReturnType<Mutations[K]>;
} & Omit<ActionContext<State, RootState>, 'commit'>

export interface Actions {
  [CountriesActionTypes.GET_COUNTRIES](
    { commit }: AugmentedActionContext,
    payload: any
  );
  [CountriesActionTypes.GET_COUNTRY_CODE](
    { commit }: AugmentedActionContext
  );
}

export const actions: ActionTree<State, RootState> & Actions = {
  async [CountriesActionTypes.GET_COUNTRIES]({ commit },payload) {
    try {

      // const payload = {
      //   lang: window.localStorage.getItem('language'),
      //   isDropdown: true 
      // }
      const newPayload = {...payload}
      newPayload.lang = window.localStorage.getItem('language')
      newPayload.isDropdown = true

      const data = await axios.post(Links.GET_COUNTRIES, newPayload);
      commit(CountriesMutationTypes.SET_COUNTRIES, data.data.data.countries);
      isCalled.getCountries = true;
    }
    catch (err) {
      return err;
    }
  },

  async [CountriesActionTypes.GET_COUNTRY_CODE]({ commit }) {
    try {
      if (isCalled.getCountryCode) return;
      const payload = {
        lang: window.localStorage.getItem('language'),
        isDropdown: true
      }
      const data = await axios.post(Links.GET_COUNTRIES_CODE, payload);
      commit(CountriesMutationTypes.SET_COUNTRY_CODE, data.data.data.codes);
      isCalled.getCountryCode = true;
    }
    catch (err) {
      return err;
    }
  },

  async [CountriesActionTypes.GET_COMPANY_INFO]({ commit }) {
    let lang = window.localStorage.getItem('language')
    if(!lang) {
      lang = 'en'
    }
    const data = await axios.post(Links.GET_COMPANY_INFO,{ lang : lang});
    try {
      commit(CountriesMutationTypes.SET_COMPANY_INFO, data.data.data);
    }
    catch(err) {
      console.log(err)
    }
  },
};
